import React, { useState } from "react";
import { Route, Routes } from "react-router";
import VehicleEntranceSearch from "../component/vehicle-entrance/VehicleEntranceSearch";
import { GenericTitleHeader } from "../component/common/GenericTitleHeader";
import useOperationTranslation from "../hooks/useOperationTranslation";
import VehicleEntranceInternalDDT from "../component/vehicle-entrance/VehicleEntranceInternalDDT";
import VehicleEntranceExternalDDT from "../component/vehicle-entrance/VehicleEntranceExternalDDT";
import VehicleEntrancePlate from "../component/vehicle-entrance/VehicleEntrancePlate";
import VehicleEntrancePlateCheckList from "../component/vehicle-entrance/VehicleEntrancePlateCheckList";
import VehicleEntranceExternalDDTConfirm from "../component/vehicle-entrance/VehicleEntranceExternalDDTConfirm";
import VehicleEntrancePlateMigration from "../component/vehicle-entrance/VehicleEntrancePlateMigration";
import VehicleEntranceFirstFueling from "../component/vehicle-entrance/VehicleEntranceFirstFueling";
import Box from "@mui/material/Box";
import SectionHeader from "../../../util/component/SectionHeader";

const VehicleEntrancePage = () => {
  const t = useOperationTranslation();
  const [subtitle, setSubtitle] = useState("");

  const onSubtitleChange = (subtitle: string) => {
    setSubtitle(subtitle);
  }

  return (
    <>
      <SectionHeader
          title={t("vehicleEntrance.titleBlue") + " " + t("vehicleEntrance.titleViolet")}
          subtitle={subtitle && <Box>{subtitle}</Box>}
      />
      <>
        <Routes>
          <Route index={true} element={<VehicleEntranceSearch />} />

          <Route path="/internalDDT" element={<VehicleEntranceInternalDDT changeSubtitle={onSubtitleChange} />} />
          <Route path="/externalDDT" element={<VehicleEntranceExternalDDT changeSubtitle={onSubtitleChange} />} />
          <Route path="/firstFueling/:plate" element={<VehicleEntranceFirstFueling changeSubtitle={onSubtitleChange} />} />
          <Route
            path="/externalDDT/confirm"
            element={<VehicleEntranceExternalDDTConfirm />}
          />
          <Route path="/plate" element={<VehicleEntrancePlate changeSubtitle={onSubtitleChange} />} />
          <Route
            path="/plate/migration"
            element={<VehicleEntrancePlateMigration />}
          />
          <Route
            path="/plate/checkList"
            element={<VehicleEntrancePlateCheckList />}
          />
        </Routes>
      </>
    </>
  );
};

export default VehicleEntrancePage;

